import React, { ChangeEvent, InputHTMLAttributes } from 'react';
import { PhoneInput, toDigits } from 'components/ui';
import {
  ErrorMessage,
  FieldWrapper,
  InputWrapper,
  StyledInput,
} from './input-block.styled';

type IProps = {
  showError: boolean;
  errorMessage: string;
} & InputHTMLAttributes<HTMLInputElement>;

export const InputBlock = React.memo(
  ({ showError, errorMessage, ...props }: IProps) => {
    const handlePhoneChange = (event: ChangeEvent<HTMLInputElement>) => {
      props.onChange?.({
        ...event,
        target: {
          ...event.target,
          value: toDigits(event.target.value),
        },
      } as ChangeEvent<HTMLInputElement>);
    };

    if (props.placeholder === 'Телефон') {
      return (
        <FieldWrapper>
          <PhoneInput
            style={{ width: '100%' }}
            onChange={handlePhoneChange}
            disabled={props.disabled}
            value={props.value}
          />
          {showError && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </FieldWrapper>
      );
    }

    return (
      <InputWrapper>
        <StyledInput {...props} />
        {showError && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </InputWrapper>
    );
  }
);
